export default "__VITE_ASSET__a15aeba6__"